import React from 'react';
import PropTypes from 'prop-types';
import Association from 'components/Association/Association';
import GridCardWrapper, {
  FavoriteIcon,
  ContentWrapper,
  LocationArea,
  TitleArea,
  PriceArea,
  RatingArea,
  MetaWrapper,
  ButtonGroup
} from './GridCard.style';
import { Link } from 'react-router-dom';
import { MARINA_PAGE } from 'settings/constant';

const GridCard = ({
  className,
  favorite,
  location,
  title,
  marinaName, // For Demo purpose
  price,
  id,
  associationType,
  rating,
  editBtn,
  viewDetailsBtn,
  children
}) => {
  let classes = viewDetailsBtn || editBtn ? `has_btn ${className}` : className;
  return (
    <GridCardWrapper className={`grid_card ${classes}`.trim()}>
      {children}
      <ContentWrapper className='content_wrapper'>
        {location && <LocationArea>{location}</LocationArea>}
        {title ? (
          <TitleArea>{title}</TitleArea>
        ) : (
          <TitleArea>
            <Link to={`/en${MARINA_PAGE}/${id}`}>{title}</Link>
          </TitleArea>
        )}
        <MetaWrapper className='meta_wrapper'>
          {price && <PriceArea className='price'>{price}</PriceArea>}
          {rating && <RatingArea className='rating'>{rating}</RatingArea>}
          {(viewDetailsBtn || editBtn) && (
            <ButtonGroup className='button_group'>
              {viewDetailsBtn}
              {editBtn}
            </ButtonGroup>
          )}
        </MetaWrapper>
        {className === 'info_window_card' ? null : (
          <Association
            associationType={associationType}
            marinaName={marinaName}
          />
        )}
      </ContentWrapper>
      {favorite && <FavoriteIcon>{favorite}</FavoriteIcon>}
    </GridCardWrapper>
  );
};

GridCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  price: PropTypes.string,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  editBtn: PropTypes.element,
  viewDetailsBtn: PropTypes.element
};

export default GridCard;
